import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';
import {scheduleCardSchema} from '../../../../schemas/scheduleCardSchema';
import addOrUpdateCardTool from '../../../../tools/general/addOrUpdateCardTool/addOrUpdateCardTool';
import readValuesFromExcelTool from '../../../../tools/general/readValuesFromExcelTool/readValuesFromExcelTool';
import analyzeExcelHeadersTool from 'common/src/modules/shared/copilot/tools/analyzeExcelHeadersTool/analyzeExcelHeadersTool';
import getFilesTool from 'common/src/modules/shared/copilot/tools/getFilesTool';

export default function addOrUpdateScheduleCardTool(store: CLStore) {
  return addOrUpdateCardTool({
    store,
    cardType: NodeType.SCHEDULE,
    cardSchema: scheduleCardSchema,
    tools: [readValuesFromExcelTool(), analyzeExcelHeadersTool(), getFilesTool()],
    cardSpecificInstructions: `- Fallback output is selected when no other outputs match. Capable of reading values from an excel file.
    - When generating a daterange schema, if not requested otherwise start date should be start of day (00:00:00) and end date should be end of day (23:59:59).`,
  });
}
